import { render, staticRenderFns } from "./super.vue?vue&type=template&id=2452ead4&scoped=true"
import script from "./super.vue?vue&type=script&lang=js"
export * from "./super.vue?vue&type=script&lang=js"
import style0 from "./super.vue?vue&type=style&index=0&id=2452ead4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452ead4",
  null
  
)

export default component.exports